import {createImageUrl} from "@/utils/filters";


const basicCytoscapeConfiguration =
{
        wheelSensitivity: 0.3,
        zoom: 0.7,
        pan: {x: 500, y: 200},
        minZoom: 0.1,
        maxZoom: 3,
        style: [
            {
                selector: "node",
                style: {
                    label: "data(label)",
                    "text-valign": "bottom",
                    "text-halign": "center",
                    "text-margin-y": "5px",
                    "text-wrap": "wrap",
                }
            },
            {
                selector: "edge",
                style: {
                    label: "data(label)",
                    "edge-text-rotation": "autorotate",
                    "arrow-scale": "2",
                    "curve-style": "bezier",
                    width: 3,
                    "line-color": "#ccc",
                    "target-arrow-color": "#ccc",
                    "target-arrow-shape": "triangle",
                    "source-endpoint": "outside-to-node",
                    "target-endpoint": "outside-to-node"
                }
            },
            {
                selector: ".transaction",
                style: {
                    width: "45px",
                    height: "45px",
                    shape: "diamond",
                    "background-image": createImageUrl(
                        "transaction.png"
                    ),
                    "border-color": "#424242",
                    "border-width": "4px",
                    "background-color": "#fafafa",
                    "background-height": "20px",
                    "background-width": "20px"
                }
            },
            {
                selector: ".address",
                style: {
                    width: "50px",
                    height: "50px",
                    "background-image": createImageUrl("address.png"),
                    "border-color": "#424242",
                    "border-width": "4px",
                    "background-color": "#fafafa",
                    "background-height": "20px",
                    "background-width": "20px",
                    "pie-1-background-color": "data(pie1color)",
                    "pie-1-background-size": "data(pie1size)",
                    "pie-2-background-color": "data(pie2color)",
                    "pie-2-background-size": "data(pie2size)",
                    "pie-3-background-color": "data(pie3color)",
                    "pie-3-background-size": "data(pie3size)",
                    "pie-4-background-color": "data(pie4color)",
                    "pie-4-background-size": "data(pie4size)",
                    "pie-5-background-color": "data(pie5color)",
                    "pie-5-background-size": "data(pie5size)",
                    "pie-6-background-color": "data(pie6color)",
                    "pie-6-background-size": "data(pie6size)",
                    "pie-7-background-color": "data(pie7color)",
                    "pie-7-background-size": "data(pie7size)",
                    "pie-8-background-color": "data(pie8color)",
                    "pie-8-background-size": "data(pie8size)",
                    "pie-9-background-color": "data(pie9color)",
                    "pie-9-background-size": "data(pie9size)",
                    "pie-10-background-color": "data(pie10color)",
                    "pie-10-background-size": "data(pie10size)",
                    "pie-11-background-color": "data(pie11color)",
                    "pie-11-background-size": "data(pie11size)",
                    "pie-12-background-color": "data(pie12color)",
                    "pie-12-background-size": "data(pie12size)",
                    "pie-13-background-color": "data(pie13color)",
                    "pie-13-background-size": "data(pie13size)",
                    "pie-14-background-color": "data(pie14color)",
                    "pie-14-background-size": "data(pie14size)",
                    "pie-15-background-color": "data(pie15color)",
                    "pie-15-background-size": "data(pie15size)",
                    "pie-16-background-color": "data(pie16color)",
                    "pie-16-background-size": "data(pie16size)",
                    "pie-16-background-opacity": 0.5,
                    "pie-15-background-opacity": 0.5,
                    "pie-14-background-opacity": 0.5,
                    "pie-13-background-opacity": 0.5,
                    "pie-12-background-opacity": 0.5,
                    "pie-11-background-opacity": 0.5,
                    "pie-10-background-opacity": 0.5,
                    "pie-9-background-opacity": 0.5,
                    "pie-8-background-opacity": 0.5,
                    "pie-7-background-opacity": 0.5,
                    "pie-6-background-opacity": 0.5,
                    "pie-5-background-opacity": 0.5,
                    "pie-4-background-opacity": 0.5,
                    "pie-3-background-opacity": 0.5,
                    "pie-2-background-opacity": 0.5,
                    "pie-1-background-opacity": 0.5
                }
            },
            {
                selector: ".cluster",
                style: {
                    width: "60px",
                    height: "60px",
                    shape: "square",
                    "background-image": createImageUrl("cluster.png"),
                    "border-color": "#424242",
                    "border-width": "4px",
                    "background-color": "#fafafa",
                    "background-height": "30px",
                    "background-width": "30px",
                    "pie-1-background-color": "data(pie1color)",
                    "pie-1-background-size": "data(pie1size)",
                    "pie-2-background-color": "data(pie2color)",
                    "pie-2-background-size": "data(pie2size)",
                    "pie-3-background-color": "data(pie3color)",
                    "pie-3-background-size": "data(pie3size)",
                    "pie-4-background-color": "data(pie4color)",
                    "pie-4-background-size": "data(pie4size)",
                    "pie-5-background-color": "data(pie5color)",
                    "pie-5-background-size": "data(pie5size)",
                    "pie-6-background-color": "data(pie6color)",
                    "pie-6-background-size": "data(pie6size)",
                    "pie-7-background-color": "data(pie7color)",
                    "pie-7-background-size": "data(pie7size)",
                    "pie-8-background-color": "data(pie8color)",
                    "pie-8-background-size": "data(pie8size)",
                    "pie-9-background-color": "data(pie9color)",
                    "pie-9-background-size": "data(pie9size)",
                    "pie-10-background-color": "data(pie10color)",
                    "pie-10-background-size": "data(pie10size)",
                    "pie-11-background-color": "data(pie11color)",
                    "pie-11-background-size": "data(pie11size)",
                    "pie-12-background-color": "data(pie12color)",
                    "pie-12-background-size": "data(pie12size)",
                    "pie-13-background-color": "data(pie13color)",
                    "pie-13-background-size": "data(pie13size)",
                    "pie-14-background-color": "data(pie14color)",
                    "pie-14-background-size": "data(pie14size)",
                    "pie-15-background-color": "data(pie15color)",
                    "pie-15-background-size": "data(pie15size)",
                    "pie-16-background-color": "data(pie16color)",
                    "pie-16-background-size": "data(pie16size)",
                    "pie-16-background-opacity": 0.5,
                    "pie-15-background-opacity": 0.5,
                    "pie-14-background-opacity": 0.5,
                    "pie-13-background-opacity": 0.5,
                    "pie-12-background-opacity": 0.5,
                    "pie-11-background-opacity": 0.5,
                    "pie-10-background-opacity": 0.5,
                    "pie-9-background-opacity": 0.5,
                    "pie-8-background-opacity": 0.5,
                    "pie-7-background-opacity": 0.5,
                    "pie-6-background-opacity": 0.5,
                    "pie-5-background-opacity": 0.5,
                    "pie-4-background-opacity": 0.5,
                    "pie-3-background-opacity": 0.5,
                    "pie-2-background-opacity": 0.5,
                    "pie-1-background-opacity": 0.5
                }
            },
            {
                selector: ".belongs_to",
                style: {
                    width: 1,
                    "line-style": "dashed",
                    "line-color": "#ff6767",
                    "target-arrow-shape": "none"
                }
            },
            {
                selector: ".transfer",
                style: {
                    width: 3,
                    "line-color": "#ccc",
                    "target-arrow-color": "#ccc",
                    "target-arrow-shape": "triangle"
                }
            },
            {
                selector: ".selected",
                style: {
                    "border-color": "#2d86ec",
                    "border-style": "double",
                    "border-width": "5px",
                }
            },
        ]
}

const createInitConfig = (vuetifyCurrentTheme) => {

    //todo default values
    let result = [];
    // todo FE better structure for keypairvalues { currency, hexColorCode } for currencies
    // this is workaround and generate classes for all keys in theme.currentTheme
    // same as theme.themes["light"] (theme is by default set to light)  in ~\resources\assets\js\plugins\vuetify.js

    //todo FE is vuetify theme changing at runtime? if not, is it possible to get donfig from ../vuetify.js
    for (let [curr, color] of Object.entries(vuetifyCurrentTheme)) {
        result.push({
            selector: "." + curr + "-edge",
            style: {
                "line-color": color,
                "target-arrow-color": color
            }
        });
    }
    basicCytoscapeConfiguration.style = basicCytoscapeConfiguration.style.concat(result);
    return basicCytoscapeConfiguration;
};


const graphLayoutConfig = {
    name: 'klay',
    nodeDimensionsIncludeLabels: false, // Boolean which changes whether label dimensions are included when calculating node dimensions
    fit: true, // Whether to fit
    padding: 100, // Padding on fit
    animate: false, // Whether to transition the node positions
    animateFilter: function (node, i) {
        return true;
    }, // Whether to animate specific nodes when animation is on; non-animated nodes immediately go to their final positions
    animationDuration: 500, // Duration of animation in ms if enabled
    animationEasing: undefined, // Easing of animation if enabled
    transform: function (node, pos) {
        return pos;
    }, // A function that applies a transform to the final node position
    ready: undefined, // Callback on layoutready
    stop: undefined, // Callback on layoutstop
    klay: {
        // Following descriptions taken from http://layout.rtsys.informatik.uni-kiel.de:9444/Providedlayout.html?algorithm=de.cau.cs.kieler.klay.layered
        addUnnecessaryBendpoints: false, // Adds bend points even if an edge does not change direction.
        aspectRatio: 1, // The aimed aspect ratio of the drawing, that is the quotient of width by height
        borderSpacing: 20, // Minimal amount of space to be left to the border
        compactComponents: false, // Tries to further compact components (disconnected sub-graphs).
        crossingMinimization: 'LAYER_SWEEP', // Strategy for crossing minimization.
        /* LAYER_SWEEP The layer sweep algorithm iterates multiple times over the layers, trying to find node orderings that minimize the number of crossings. The algorithm uses randomization to increase the odds of finding a good result. To improve its results, consider increasing the Thoroughness option, which influences the number of iterations done. The Randomization seed also influences results.
        INTERACTIVE Orders the nodes of each layer by comparing their positions before the layout algorithm was started. The idea is that the relative order of nodes as it was before layout was applied is not changed. This of course requires valid positions for all nodes to have been set on the input graph before calling the layout algorithm. The interactive layer sweep algorithm uses the Interactive Reference Point option to determine which reference point of nodes are used to compare positions. */
        cycleBreaking: 'GREEDY', // Strategy for cycle breaking. Cycle breaking looks for cycles in the graph and determines which edges to reverse to break the cycles. Reversed edges will end up pointing to the opposite direction of regular edges (that is, reversed edges will point left if edges usually point right).
        /* GREEDY This algorithm reverses edges greedily. The algorithm tries to avoid edges that have the Priority property set.
        INTERACTIVE The interactive algorithm tries to reverse edges that already pointed leftwards in the input graph. This requires node and port coordinates to have been set to sensible values.*/
        direction: 'UNDEFINED', // Overall direction of edges: horizontal (right / left) or vertical (down / up)
        /* UNDEFINED, RIGHT, LEFT, DOWN, UP */
        edgeRouting: 'ORTHOGONAL', // Defines how edges are routed (POLYLINE, ORTHOGONAL, SPLINES)
        edgeSpacingFactor: 0.5, // Factor by which the object spacing is multiplied to arrive at the minimal spacing between edges.
        feedbackEdges: false, // Whether feedback edges should be highlighted by routing around the nodes.
        fixedAlignment: 'NONE', // Tells the BK node placer to use a certain alignment instead of taking the optimal result.  This option should usually be left alone.
        /* NONE Chooses the smallest layout from the four possible candidates.
        LEFTUP Chooses the left-up candidate from the four possible candidates.
        RIGHTUP Chooses the right-up candidate from the four possible candidates.
        LEFTDOWN Chooses the left-down candidate from the four possible candidates.
        RIGHTDOWN Chooses the right-down candidate from the four possible candidates.
        BALANCED Creates a balanced layout from the four possible candidates. */
        inLayerSpacingFactor: 1.0, // Factor by which the usual spacing is multiplied to determine the in-layer spacing between objects.
        layoutHierarchy: false, // Whether the selected layouter should consider the full hierarchy
        linearSegmentsDeflectionDampening: 0.3, // Dampens the movement of nodes to keep the diagram from getting too large.
        mergeEdges: false, // Edges that have no ports are merged so they touch the connected nodes at the same points.
        mergeHierarchyCrossingEdges: true, // If hierarchical layout is active, hierarchy-crossing edges use as few hierarchical ports as possible.
        nodeLayering: 'NETWORK_SIMPLEX', // Strategy for node layering.
        /* NETWORK_SIMPLEX This algorithm tries to minimize the length of edges. This is the most computationally intensive algorithm. The number of iterations after which it aborts if it hasn't found a result yet can be set with the Maximal Iterations option.
        LONGEST_PATH A very simple algorithm that distributes nodes along their longest path to a sink node.
        INTERACTIVE Distributes the nodes into layers by comparing their positions before the layout algorithm was started. The idea is that the relative horizontal order of nodes as it was before layout was applied is not changed. This of course requires valid positions for all nodes to have been set on the input graph before calling the layout algorithm. The interactive node layering algorithm uses the Interactive Reference Point option to determine which reference point of nodes are used to compare positions. */
        nodePlacement: 'BRANDES_KOEPF', // Strategy for Node Placement
        /* BRANDES_KOEPF Minimizes the number of edge bends at the expense of diagram size: diagrams drawn with this algorithm are usually higher than diagrams drawn with other algorithms.
        LINEAR_SEGMENTS Computes a balanced placement.
        INTERACTIVE Tries to keep the preset y coordinates of nodes from the original layout. For dummy nodes, a guess is made to infer their coordinates. Requires the other interactive phase implementations to have run as well.
        SIMPLE Minimizes the area at the expense of... well, pretty much everything else. */
        randomizationSeed: 1, // Seed used for pseudo-random number generators to control the layout algorithm; 0 means a new seed is generated
        routeSelfLoopInside: false, // Whether a self-loop is routed around or inside its node.
        separateConnectedComponents: true, // Whether each connected component should be processed separately
        spacing: 150, // Overall setting for the minimal amount of space to be left between objects
        thoroughness: 7 // How much effort should be spent to produce a nice layout..
    },
    priority: function (edge) {
        return null;
    }, // Edges with a non-nil value are skipped when geedy edge cycle breaking is enabled
};

export {createInitConfig, graphLayoutConfig}